



















// import React, { useEffect, useState, useMemo } from "react";
// import "./Usermanagement.css"; // Import the CSS file
// import { Link } from "react-router-dom";
// import ProfessionalUser from "./ProfessionalUser";
// import PostPaidUsers from "./PostPaidUsers";

// // Inline loader hook
// const useInlineLoader = () => {
//     const [loading, setLoading] = useState(false);
//     const [fadeOut, setFadeOut] = useState(false);

//     const showLoader = () => {
//         setFadeOut(false);
//         setLoading(true);
//     };

//     const hideLoader = () => {
//         setFadeOut(true);
//         setTimeout(() => {
//             setLoading(false);
//             setFadeOut(false);
//         }, 500);
//     };

//     return { showLoader, hideLoader, loading, fadeOut };
// };

// const Userdetails = () => {
//     const [selectedCustomer, setSelectedCustomer] = useState(null);
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
//     const [activeTab, setActiveTab] = useState("User"); // New tab state

//     // Use inline loader
//     const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

//     // Filtered data for User tab
//     const filteredData = useMemo(() => {
//         return data.filter(user => {
//             const statusMatch = !selectedStatusFilter ||
//                 user.active === (selectedStatusFilter === "true");
//             const categoryMatch = !selectedCategoryFilter ||
//                 (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
//             return statusMatch && categoryMatch;
//         });
//     }, [data, selectedStatusFilter, selectedCategoryFilter]);

//     // Tab content mapping
//     const tabContent = {
//         "User": <UserTabContent
//             data={data}
//             selectedStatusFilter={selectedStatusFilter}
//             setSelectedStatusFilter={setSelectedStatusFilter}
//             selectedCategoryFilter={selectedCategoryFilter}
//             setSelectedCategoryFilter={setSelectedCategoryFilter}
//             filteredData={filteredData}
//         />,
//         "Enterprise User": <ProfessionalUser />, // Using the imported component
//     };

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {
//         const controller = new AbortController();
//         const authToken = localStorage.getItem("authToken");

//         const fetchUsers = async () => {
//             try {
//                 showLoader(); // Show loader when fetching starts
//                 const res = await fetch(
//                     "https://backend.maamaas.com/subscription/api/admin/getallusers",
//                     {
//                         signal: controller.signal,
//                         headers: {
//                             "Content-Type": "application/json",
//                             "Authorization": `Bearer ${authToken}`,
//                         },
//                     }
//                 );

//                 if (!res.ok) {
//                     throw new Error(`HTTP error! status: ${res.status}`);
//                 }

//                 const fetchedData = await res.json();

//                 // ✅ FILTER ONLY PERSONAL USERS
//                 const personalUsers = fetchedData.filter(
//                     (item) => item.userType === "PERSONAL"
//                 );

//                 const dataWithSno = personalUsers.map((item, index) => ({
//                     ...item,
//                     sno: index + 1,
//                     category: item.category || "N/A",
//                     subscription: item.subscription || "N/A",
//                     orders: typeof item.orders === "number" ? item.orders : 0,
//                     last: item.lastOrderDate || item.last || "N/A",
//                     statusAsDeliveryAgent:
//                         item.status || item.statusAsDeliveryAgent || "N/A",
//                 }));

//                 setData(dataWithSno);
//             } catch (err) {
//                 if (err.name !== "AbortError") {
//                     console.error("Error fetching users:", err);
//                 }
//             } finally {
//                 hideLoader(); // Hide loader when done
//             }
//         };

//         fetchUsers();

//         return () => controller.abort();
//     }, []);

//     const openModal = (user) => setSelectedCustomer(user);
//     const closeModal = () => setSelectedCustomer(null);

//     return (
//         <div className="container-fluid p-0 client-managment-data">
//             {/* Global Loader */}
//             {globalLoading && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     background: 'rgba(0,0,0,0.95)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 999999,
//                     transition: 'opacity 0.4s ease',
//                     fontFamily: 'Arial, sans-serif',
//                     opacity: fadeOut ? 0 : 1,
//                     pointerEvents: fadeOut ? 'none' : 'auto'
//                 }}>
//                     <div style={{ textAlign: 'center' }}>
//                         <div style={{
//                             fontSize: '2rem',
//                             fontWeight: 900,
//                             letterSpacing: '6px',
//                             marginBottom: '30px',
//                         }}>
//                             {"MAAMAAS".split("").map((l, i) => (
//                                 <span
//                                     key={i}
//                                     style={{
//                                         display: 'inline-block',
//                                         opacity: 0,
//                                         transform: 'translateY(30px)',
//                                         animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
//                                         color: '#e50914',
//                                     }}
//                                 >
//                                     {l}
//                                 </span>
//                             ))}
//                         </div>

//                         <div style={{
//                             width: '280px',
//                             height: '4px',
//                             background: 'rgba(255,255,255,0.2)',
//                             overflow: 'hidden',
//                             margin: '0 auto',
//                         }}>
//                             <div style={{
//                                 width: '40%',
//                                 height: '100%',
//                                 background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
//                                 animation: 'progress 1.8s infinite',
//                             }}></div>
//                         </div>

//                         <div style={{
//                             marginTop: '20px',
//                             color: '#aaa',
//                             fontSize: '14px',
//                         }}>
//                             Loading user data...
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <div className="row g-0" style={{ marginTop: '90px', height: "92vh" }}>
//                 {/* <div className="col-lg-2"></div> */}
//                 <div className="col-lg-12">


//                     {/* Tab Buttons Container - Fixed position */}
//                    {/* Tab Buttons Container - Fixed position */}
// <div className="sticky-top py-1 px-1" style={{ top: '66px' }}>
//     <div className="row g-2 justify-content-start">
//                             {Object.keys(tabContent).map((label) => (
//                                 <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
//                                     <button
//                                         onClick={() => setActiveTab(label)}
//                                         style={{
//                                             border: "none",
//                                             borderRadius: "10px",
//                                             minWidth: "140px",
//                                             width: "100%",
//                                             padding: "0 10px",
//                                             height: "40px",
//                                             backgroundColor: activeTab === label ? "rgb(230 109 51)" : "#d9d9d9",
//                                             color: activeTab === label ? "#fff" : "#000",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             transition: "background-color 0.3s ease",
//                                             fontSize: "1rem",
//                                         }}
//                                     >
//                                         {label}
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Tab Content Container - Scrollable area */}
//                     <div
//                         style={{
//                             height: `calc(100vh - 75px - 60px)`,
//                             overflowY: "auto",
//                             scrollbarWidth: "none",
//                             padding: "10px",
//                         }}
//                         className=""
//                     >
//                         <style>{`
//               div::-webkit-scrollbar { 
//                 display: none; 
//               }
//             `}</style>
//                         {tabContent[activeTab]}
//                     </div>
//                 </div>
//             </div>

//             {/* Add loader animations to existing style */}
//             <style>{`
//                 @keyframes letterAnim {
//                     0% { opacity: 0; transform: translateY(30px); }
//                     100% { opacity: 1; transform: translateY(0); }
//                 }

//                 @keyframes progress {
//                     0% { transform: translateX(-100%); }
//                     100% { transform: translateX(250%); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // User Tab Component with side-by-side dropdown and search
// // User Tab Component with side-by-side dropdown and search
// const UserTabContent = ({
//     data,
//     selectedStatusFilter,
//     setSelectedStatusFilter,
//     selectedCategoryFilter,
//     setSelectedCategoryFilter,
//     filteredData
// }) => {
//     const [searchType, setSearchType] = useState("userId"); // Default search type
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedCustomer, setSelectedCustomer] = useState(null);
//     const [loadingProfile, setLoadingProfile] = useState(false);

//     // Use inline loader for user profile loading
//     const { showLoader: showProfileLoader, hideLoader: hideProfileLoader, loading: profileLoading, fadeOut: profileFadeOut } = useInlineLoader();

//     // Search options for dropdown
//     const searchOptions = [
//         { value: "userId", label: "User ID" },
//         { value: "userName", label: "User Name" },
//         { value: "email", label: "Email" },
//         { value: "mobileNumber", label: "Mobile Number" }
//     ];
//     const formatDate = (dateValue) => {
//         if (!dateValue) return "-";
//         const date = new Date(dateValue);

//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0");
//         const year = date.getFullYear();

//         return `${day}/${month}/${year}`;
//     };

//     const formatTime = (dateValue) => {
//         if (!dateValue) return "-";
//         const date = new Date(dateValue);

//         const hours = String(date.getHours()).padStart(2, "0");
//         const minutes = String(date.getMinutes()).padStart(2, "0");
//         const seconds = String(date.getSeconds()).padStart(2, "0");

//         return `${hours}:${minutes}:${seconds}`;
//     };

//     // Filter data based on selected search type and query
//     const searchFilteredData = useMemo(() => {
//         if (!searchQuery.trim()) {
//             return filteredData;
//         }

//         const query = searchQuery.toLowerCase().trim();

//         return filteredData.filter(user => {
//             const fieldValue = user[searchType];

//             if (!fieldValue) return false;

//             // Special handling for mobile number search
//             if (searchType === "mobileNumber") {
//                 const cleanUserMobile = fieldValue.toString().replace(/\D/g, '');
//                 const cleanQuery = query.replace(/\D/g, '');
//                 return fieldValue.toString().toLowerCase().includes(query) ||
//                     cleanUserMobile.includes(cleanQuery);
//             }

//             // For other fields (userId, userName, email)
//             return fieldValue.toString().toLowerCase().includes(query);
//         });
//     }, [filteredData, searchType, searchQuery]);

//     // Fixed export function
//     const handleExportFiltered = () => {
//         // Use searchFilteredData instead of data
//         const exportData = searchFilteredData.length > 0 ? searchFilteredData : filteredData;

//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO",
//             "Customer ID",
//             "Name",
//             "Email",
//             "Phone Number",
//             "Status"
//         ];

//         // Map the filtered data for export
//         const csvRows = exportData.map((user, index) => [
//             index + 1,
//             user.userId || 'N/A',
//             user.userName || 'N/A',
//             user.emailId || 'N/A',
//             user.mobileNumber || 'N/A',
//             user.active ? "Active" : "Inactive"
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "filtered_users.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     // Clear all search filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedStatusFilter("");
//         setSelectedCategoryFilter("");
//     };

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "userId": return "Search User ID";
//             case "userName": return "Search Name";
//             case "email": return "Search Email";
//             case "mobileNumber": return "Search Mobile";
//             default: return "Search...";
//         }
//     };

//     const fetchUserProfileById = async (userId) => {
//         const token = localStorage.getItem("authToken");
//         setLoadingProfile(true);
//         showProfileLoader(); // Show loader when fetching profile

//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`,
//                 {
//                     method: "GET",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error("Failed to fetch user profile");
//             }

//             const data = await response.json();
//             setSelectedCustomer(data);   // 👈 FULL PROFILE DATA
//         } catch (error) {
//             console.error("Error fetching user profile:", error);
//             alert("Unable to fetch user details");
//         } finally {
//             setLoadingProfile(false);
//             hideProfileLoader(); // Hide loader when done
//         }
//     };

//     return (
//         <div className="user-management-container" style={{ marginTop: '0px' }}>
//             {/* Profile Loading Loader */}
//             {profileLoading && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     background: 'rgba(0,0,0,0.95)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 999998,
//                     transition: 'opacity 0.4s ease',
//                     fontFamily: 'Arial, sans-serif',
//                     opacity: profileFadeOut ? 0 : 1,
//                     pointerEvents: profileFadeOut ? 'none' : 'auto'
//                 }}>
//                     <div style={{ textAlign: 'center' }}>
//                         <div style={{
//                             fontSize: '2rem',
//                             fontWeight: 900,
//                             letterSpacing: '6px',
//                             marginBottom: '30px',
//                         }}>
//                             {"MAAMAAS".split("").map((l, i) => (
//                                 <span
//                                     key={i}
//                                     style={{
//                                         display: 'inline-block',
//                                         opacity: 0,
//                                         transform: 'translateY(30px)',
//                                         animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
//                                         color: '#e50914',
//                                     }}
//                                 >
//                                     {l}
//                                 </span>
//                             ))}
//                         </div>

//                         <div style={{
//                             width: '280px',
//                             height: '4px',
//                             background: 'rgba(255,255,255,0.2)',
//                             overflow: 'hidden',
//                             margin: '0 auto',
//                         }}>
//                             <div style={{
//                                 width: '40%',
//                                 height: '100%',
//                                 background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
//                                 animation: 'progress 1.8s infinite',
//                             }}></div>
//                         </div>

//                         <div style={{
//                             marginTop: '20px',
//                             color: '#aaa',
//                             fontSize: '14px',
//                         }}>
//                             Loading user profile...
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <div className="row g-2 mb-1 align-items-center me-0">
//                 {/* Search Type Dropdown and Search Input - Side by Side */}
//                 <div className="col-md-auto col-12">
//                     <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                         {/* Search Type Dropdown */}
//                         <div style={{ minWidth: '150px' }}>
//                             <select
//                                 className="form-select"
//                                 value={searchType}
//                                 onChange={(e) => setSearchType(e.target.value)}
//                                 style={{ height: "40px" }}
//                             >
//                                 {searchOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Search Input */}
//                         <div style={{ minWidth: '200px' }}>
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder={getPlaceholderText()}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{ height: "40px" }}
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 {/* Status Filter */}
//                 <div className="col-md-auto col-12">
//                     <select
//                         className="form-select"
//                         value={selectedStatusFilter}
//                         onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                         aria-label="Filter by status"
//                         style={{ maxWidth: '150px', height: "40px" }}
//                     >
//                         <option value="">All Status</option>
//                         <option value="true">Active</option>
//                         <option value="false">Inactive</option>
//                     </select>
//                 </div>

//                 {/* Clear Filters Button */}
//                 <div className="col-md-auto col-12">
//                     <button
//                         className="btn"
//                         onClick={clearAllFilters}
//                         style={{
//                             backgroundColor: '#6c757d',
//                             color: '#fff',
//                             height: "40px",
//                             padding: "0 15px"
//                         }}
//                     >
//                         Clear Filters
//                     </button>
//                 </div>

//                 {/* Export Button */}
//                 <div className="col-md col-12">
//                     <div className="d-flex justify-content-start justify-content-md-end">
//                         <button
//                             className="btn"
//                             onClick={handleExportFiltered}
//                             style={{
//                                 backgroundColor: 'rgb(230 109 51)',
//                                 color: '#fff',
//                                 height: "40px",
//                                 padding: "0 20px"
//                             }}
//                         >
//                             Export
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Users Table with Fixed Headers */}
//             <div className="user-table-container" style={{
//                 marginTop: '10px',
//                 border: '1px solid #ddd',
//                 borderRadius: '4px',
//                 overflow: 'hidden'
//             }}>
//                 {/* Fixed Header Table */}
//                 <div style={{
//                     overflow: 'hidden',
//                     backgroundColor: '#fff'
//                 }}>
//                     <table style={{
//                         width: "100%",
//                         fontSize: "0.95rem",
//                         borderCollapse: "collapse",
//                         tableLayout: 'fixed' // Fixed layout for better column alignment
//                     }}>
//                         <thead>
//                             <tr>
//                                 <th style={{ ...tableHeaderStyle, width: '50px' }}>S.NO</th>
//                                 <th style={{ ...tableHeaderStyle, width: '80px' }}>Date</th>
//                                 <th style={{ ...tableHeaderStyle, width: '80px' }}>Time</th>
//                                 <th style={{ ...tableHeaderStyle, width: '100px' }}>Name</th>
//                                 <th style={{ ...tableHeaderStyle, width: '100px' }}>User ID</th>
//                                 <th style={{ ...tableHeaderStyle, width: '150px' }}>Email</th>
//                                 <th style={{ ...tableHeaderStyle, width: '100px' }}>Phone Number</th>
//                                 <th style={{ ...tableHeaderStyle, width: '90px' }}>User Type</th>
//                                 <th style={{ ...tableHeaderStyle, width: '70px' }}>Status</th>
//                                 <th style={{ ...tableHeaderStyle, width: '70px' }}>View</th>
//                             </tr>
//                         </thead>
//                     </table>
//                 </div>

//                 {/* Scrollable Body Table */}
//                 <div style={{
//                     maxHeight: "450px",
//                     overflowY: "auto",
//                     overflowX: 'hidden'
//                 }}>
//                     <table style={{
//                         width: "100%",
//                         fontSize: "0.95rem",
//                         borderCollapse: "collapse",
//                         tableLayout: 'fixed' // Same fixed layout as header
//                     }}>
//                         <tbody>
//                             {searchFilteredData.length > 0 ? (
//                                 searchFilteredData.map((user, index) => (
//                                     <tr
//                                         key={user.userId || index}
//                                         style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
//                                     >
//                                         <td style={{ ...tableCellStyle, width: '50px' }}>{index + 1}</td>

//                                         {/* DATE */}
//                                         <td style={{ ...tableCellStyle, width: '80px' }}>
//                                             {formatDate(user.registeredTime)}
//                                         </td>

//                                         {/* TIME */}
//                                         <td style={{ ...tableCellStyle, width: '80px' }}>
//                                             {formatTime(user.registeredTime)}
//                                         </td>

//                                         <td style={{ ...tableCellStyle, width: '100px' }}>{user.userName}</td>
//                                         <td style={{ ...tableCellStyle, width: '100px' }}>{user.userId}</td>
//                                         <td style={{ ...tableCellStyle, width: '150px' }}>{user.emailId}</td>
//                                         <td style={{ ...tableCellStyle, width: '100px' }}>{user.mobileNumber}</td>
//                                         <td style={{ ...tableCellStyle, width: '90px' }}>{user.userType}</td>
//                                         <td style={{ ...tableCellStyle, width: '70px' }}>
//                                             {user.active ? "Active" : "Inactive"}
//                                         </td>
//                                         <td style={{ ...tableCellStyle, width: '70px' }}>
//                                             <button style={viewBtn} onClick={() => fetchUserProfileById(user.userId)}>View</button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="10" style={noDataStyle}>
//                                         {data.length === 0
//                                             ? "Loading data or no users found."
//                                             : (searchQuery.trim() || selectedStatusFilter || selectedCategoryFilter)
//                                                 ? "No users found with the specified filters."
//                                                 : "No users match the current filters."}
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {selectedCustomer && (
//                 <div style={overlay}>
//                     <div style={modal}>
//                         <h4>User Details</h4>
//                         <hr />

//                         {loadingProfile ? (
//                             <p>Loading user details...</p>
//                         ) : (
//                             <>
//                                 <p><b>Name:</b> {selectedCustomer.userName || "-"}</p>
//                                 <p><b>Email:</b> {selectedCustomer.emailId || "-"}</p>
//                                 <p><b>Mobile:</b> {selectedCustomer.mobileNumber || "-"}</p>

//                                 <p><b>Referral Code:</b> {selectedCustomer.referralCode || "-"}</p>
//                                 <p><b>Total Referrals:</b> {selectedCustomer.totalReferals ?? 0}</p>
//                                 <p><b>Total Cashback:</b> ₹{selectedCustomer.totalCashBack ?? 0}</p>

//                                 {/* Optional Image */}
//                                 {selectedCustomer.image && (
//                                     <div style={{ marginTop: "10px" }}>
//                                         <b>Profile Image:</b><br />
//                                         <img
//                                             src={selectedCustomer.image}
//                                             alt="Profile"
//                                             style={{ width: "80px", height: "80px", borderRadius: "50%" }}
//                                         />
//                                     </div>
//                                 )}
//                             </>
//                         )}

//                         <div style={{ textAlign: "right", marginTop: "15px" }}>
//                             <button
//                                 style={closeBtn}
//                                 onClick={() => setSelectedCustomer(null)}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// // Professional User Tab Component (Already imported)
// // Post Paid Users Tab Component (Already imported)
// const tableHeaderStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     fontWeight: "bold",
//     backgroundColor: "rgb(230 109 51)",
//     color: "white",
//     padding: "6px",
// };

// const tableCellStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     padding: "6px",
// };

// const viewBtn = {
//     background: "rgb(230 109 51)",
//     color: "#fff",
//     border: "none",
//     padding: "4px 12px",
//     borderRadius: "6px",
//     cursor: "pointer",
// };

// const closeBtn = {
//     background: "#dc3545",
//     color: "#fff",
//     border: "none",
//     padding: "6px 16px",
//     borderRadius: "6px",
// };

// const overlay = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     background: "rgba(0,0,0,0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 10000,
// };

// const modal = {
//     background: "#fff",
//     padding: "20px",
//     borderRadius: "10px",
//     width: "400px",
// };
// const noDataStyle = {
//     fontStyle: "italic",
//     textAlign: "center",
//     padding: "10px",
//     color: "#888",
// };

// export default Userdetails;



















import React, { useEffect, useState, useMemo } from "react";
import "./Usermanagement.css"; // Import the CSS file
import { Link } from "react-router-dom";
import ProfessionalUser from "./ProfessionalUser";
import PostPaidUsers from "./PostPaidUsers";

// Inline loader hook
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

const Userdetails = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
    const [activeTab, setActiveTab] = useState("User"); // New tab state

    // Use inline loader
    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

    // Filtered data for User tab
    const filteredData = useMemo(() => {
        return data.filter(user => {
            const statusMatch = !selectedStatusFilter ||
                user.active === (selectedStatusFilter === "true");
            const categoryMatch = !selectedCategoryFilter ||
                (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
            return statusMatch && categoryMatch;
        });
    }, [data, selectedStatusFilter, selectedCategoryFilter]);

    // Tab content mapping
    const tabContent = {
        "User": <UserTabContent
            data={data}
            selectedStatusFilter={selectedStatusFilter}
            setSelectedStatusFilter={setSelectedStatusFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            setSelectedCategoryFilter={setSelectedCategoryFilter}
            filteredData={filteredData}
        />,
        "Enterprise User": <ProfessionalUser />, // Using the imported component
    };

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const authToken = localStorage.getItem("authToken");

        const fetchUsers = async () => {
            try {
                showLoader(); // Show loader when fetching starts
                const res = await fetch(
                    "https://backend.maamaas.com/subscription/api/admin/getallusers",
                    {
                        signal: controller.signal,
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${authToken}`,
                        },
                    }
                );

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const fetchedData = await res.json();

                // ✅ FILTER ONLY PERSONAL USERS
                const personalUsers = fetchedData.filter(
                    (item) => item.userType === "PERSONAL"
                );

                const dataWithSno = personalUsers.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    orders: typeof item.orders === "number" ? item.orders : 0,
                    last: item.lastOrderDate || item.last || "N/A",
                    statusAsDeliveryAgent:
                        item.status || item.statusAsDeliveryAgent || "N/A",
                }));

                setData(dataWithSno);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            } finally {
                hideLoader(); // Hide loader when done
            }
        };

        fetchUsers();

        return () => controller.abort();
    }, []);

    const openModal = (user) => setSelectedCustomer(user);
    const closeModal = () => setSelectedCustomer(null);

    return (
        <div className="container-fluid p-0 client-managment-data">
            {/* Global Loader */}
            {globalLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    transition: 'opacity 0.4s ease',
                    fontFamily: 'Arial, sans-serif',
                    opacity: fadeOut ? 0 : 1,
                    pointerEvents: fadeOut ? 'none' : 'auto'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '2rem',
                            fontWeight: 900,
                            letterSpacing: '6px',
                            marginBottom: '30px',
                        }}>
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    style={{
                                        display: 'inline-block',
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                        color: '#e50914',
                                    }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>

                        <div style={{
                            width: '280px',
                            height: '4px',
                            background: 'rgba(255,255,255,0.2)',
                            overflow: 'hidden',
                            margin: '0 auto',
                        }}>
                            <div style={{
                                width: '40%',
                                height: '100%',
                                background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                                animation: 'progress 1.8s infinite',
                            }}></div>
                        </div>

                        <div style={{
                            marginTop: '20px',
                            color: '#aaa',
                            fontSize: '14px',
                        }}>
                            Loading user data...
                        </div>
                    </div>
                </div>
            )}

            <div className="row g-0" style={{ marginTop: '90px', height: "92vh" }}>
                {/* <div className="col-lg-2"></div> */}
                <div className="col-lg-12">


                    {/* Tab Buttons Container - Fixed position */}
                    {/* Tab Buttons Container - Fixed position */}
                    <div className="sticky-top py-1 px-1" style={{ top: '66px' }}>
                        <div className="row g-2 justify-content-start">
                            {Object.keys(tabContent).map((label) => (
                                <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "rgb(230 109 51)" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Tab Content Container - Scrollable area */}
                    <div
                        style={{
                            height: `calc(100vh - 75px - 60px)`,
                            overflowY: "auto",
                            scrollbarWidth: "none",
                            padding: "10px",
                        }}
                        className=""
                    >
                        <style>{`
              div::-webkit-scrollbar { 
                display: none; 
              }
            `}</style>
                        {tabContent[activeTab]}
                    </div>
                </div>
            </div>

            {/* Add loader animations to existing style */}
            <style>{`
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }

                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
            `}</style>
        </div>
    );
};

// User Tab Component with side-by-side dropdown and search
const UserTabContent = ({
    data,
    selectedStatusFilter,
    setSelectedStatusFilter,
    selectedCategoryFilter,
    setSelectedCategoryFilter,
    filteredData
}) => {
    const [searchType, setSearchType] = useState("userId"); // Default search type
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loadingProfile, setLoadingProfile] = useState(false);

    // Use inline loader for user profile loading
    const { showLoader: showProfileLoader, hideLoader: hideProfileLoader, loading: profileLoading, fadeOut: profileFadeOut } = useInlineLoader();

    // Search options for dropdown
    const searchOptions = [
        { value: "userId", label: "User ID" },
        { value: "userName", label: "User Name" },
        { value: "email", label: "Email" },
        { value: "mobileNumber", label: "Mobile Number" }
    ];

    // Field mapping for search types to actual data fields
    const fieldMapping = {
        userId: 'userId',
        userName: 'userName',
        email: 'emailId',  // Map 'email' search type to 'emailId' field
        mobileNumber: 'mobileNumber'
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return "-";
        const date = new Date(dateValue);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const formatTime = (dateValue) => {
        if (!dateValue) return "-";
        const date = new Date(dateValue);

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
    };

    // Filter data based on selected search type and query - FIXED VERSION
    const searchFilteredData = useMemo(() => {
        if (!searchQuery.trim()) {
            return filteredData;
        }

        const query = searchQuery.toLowerCase().trim();

        return filteredData.filter(user => {
            // Get the actual field name from mapping
            const actualField = fieldMapping[searchType];
            const fieldValue = user[actualField];

            if (!fieldValue) return false;

            // Special handling for mobile number search
            if (searchType === "mobileNumber") {
                const cleanUserMobile = fieldValue.toString().replace(/\D/g, '');
                const cleanQuery = query.replace(/\D/g, '');
                return fieldValue.toString().toLowerCase().includes(query) ||
                    cleanUserMobile.includes(cleanQuery);
            }

            // For other fields (userId, userName, email)
            return fieldValue.toString().toLowerCase().includes(query);
        });
    }, [filteredData, searchType, searchQuery]);

    // Fixed export function
    const handleExportFiltered = () => {
        // Use searchFilteredData instead of data
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : filteredData;

        if (exportData.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = [
            "S.NO",
            "Customer ID",
            "Name",
            "Email",
            "Phone Number",
            "Status"
        ];

        // Map the filtered data for export
        const csvRows = exportData.map((user, index) => [
            index + 1,
            user.userId || 'N/A',
            user.userName || 'N/A',
            user.emailId || 'N/A',
            user.mobileNumber || 'N/A',
            user.active ? "Active" : "Inactive"
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "filtered_users.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    // Clear all search filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setSelectedCategoryFilter("");
    };

    // Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "userId": return "Search User ID";
            case "userName": return "Search Name";
            case "email": return "Search Email";
            case "mobileNumber": return "Search Mobile";
            default: return "Search...";
        }
    };

    const fetchUserProfileById = async (userId) => {
        const token = localStorage.getItem("authToken");
        setLoadingProfile(true);
        showProfileLoader(); // Show loader when fetching profile

        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch user profile");
            }

            const data = await response.json();
            setSelectedCustomer(data);   // 👈 FULL PROFILE DATA
        } catch (error) {
            console.error("Error fetching user profile:", error);
            alert("Unable to fetch user details");
        } finally {
            setLoadingProfile(false);
            hideProfileLoader(); // Hide loader when done
        }
    };

    return (
        <div className="user-management-container" style={{ marginTop: '0px' }}>
            {/* Profile Loading Loader */}
            {profileLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999998,
                    transition: 'opacity 0.4s ease',
                    fontFamily: 'Arial, sans-serif',
                    opacity: profileFadeOut ? 0 : 1,
                    pointerEvents: profileFadeOut ? 'none' : 'auto'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '2rem',
                            fontWeight: 900,
                            letterSpacing: '6px',
                            marginBottom: '30px',
                        }}>
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    style={{
                                        display: 'inline-block',
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                        color: '#e50914',
                                    }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>

                        <div style={{
                            width: '280px',
                            height: '4px',
                            background: 'rgba(255,255,255,0.2)',
                            overflow: 'hidden',
                            margin: '0 auto',
                        }}>
                            <div style={{
                                width: '40%',
                                height: '100%',
                                background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                                animation: 'progress 1.8s infinite',
                            }}></div>
                        </div>

                        <div style={{
                            marginTop: '20px',
                            color: '#aaa',
                            fontSize: '14px',
                        }}>
                            Loading user profile...
                        </div>
                    </div>
                </div>
            )}

            <div className="row g-2 mb-1 align-items-center me-0">
                {/* Search Type Dropdown and Search Input - Side by Side */}
                <div className="col-md-auto col-12">
                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                        {/* Search Type Dropdown */}
                        <div style={{ minWidth: '150px' }}>
                            <select
                                className="form-select"
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                                style={{ height: "40px" }}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Search Input */}
                        <div style={{ minWidth: '200px' }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ height: "40px" }}
                            />
                        </div>
                    </div>
                </div>

                {/* Status Filter */}
                <div className="col-md-auto col-12">
                    <select
                        className="form-select"
                        value={selectedStatusFilter}
                        onChange={(e) => setSelectedStatusFilter(e.target.value)}
                        aria-label="Filter by status"
                        style={{ maxWidth: '150px', height: "40px" }}
                    >
                        <option value="">All Status</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </select>
                </div>

                {/* Clear Filters Button */}
                <div className="col-md-auto col-12">
                    <button
                        className="btn"
                        onClick={clearAllFilters}
                        style={{
                            backgroundColor: '#6c757d',
                            color: '#fff',
                            height: "40px",
                            padding: "0 15px"
                        }}
                    >
                        Clear Filters
                    </button>
                </div>

                {/* Export Button */}
                <div className="col-md col-12">
                    <div className="d-flex justify-content-start justify-content-md-end">
                        <button
                            className="btn"
                            onClick={handleExportFiltered}
                            style={{
                                backgroundColor: 'rgb(230 109 51)',
                                color: '#fff',
                                height: "40px",
                                padding: "0 20px"
                            }}
                        >
                            Export
                        </button>
                    </div>
                </div>
            </div>

            {/* Users Table with Fixed Headers */}
            <div className="user-table-container" style={{
                marginTop: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                overflow: 'hidden'
            }}>
                {/* Fixed Header Table */}
                <div style={{
                    overflow: 'hidden',
                    backgroundColor: '#fff'
                }}>
                    <table style={{
                        width: "100%",
                        fontSize: "0.95rem",
                        borderCollapse: "collapse",
                        tableLayout: 'fixed' // Fixed layout for better column alignment
                    }}>
                        <thead>
                            <tr>
                                <th style={{ ...tableHeaderStyle, width: '50px' }}>S.NO</th>
                                <th style={{ ...tableHeaderStyle, width: '80px' }}>Date</th>
                                <th style={{ ...tableHeaderStyle, width: '80px' }}>Time</th>
                                <th style={{ ...tableHeaderStyle, width: '100px' }}>Name</th>
                                <th style={{ ...tableHeaderStyle, width: '100px' }}>User ID</th>
                                <th style={{ ...tableHeaderStyle, width: '150px' }}>Email</th>
                                <th style={{ ...tableHeaderStyle, width: '100px' }}>Phone Number</th>
                                <th style={{ ...tableHeaderStyle, width: '90px' }}>User Type</th>
                                <th style={{ ...tableHeaderStyle, width: '70px' }}>Status</th>
                                <th style={{ ...tableHeaderStyle, width: '70px' }}>View</th>
                            </tr>
                        </thead>
                    </table>
                </div>

                {/* Scrollable Body Table */}
                <div style={{
                    maxHeight: "450px",
                    overflowY: "auto",
                    overflowX: 'hidden'
                }}>
                    <table style={{
                        width: "100%",
                        fontSize: "0.95rem",
                        borderCollapse: "collapse",
                        tableLayout: 'fixed' // Same fixed layout as header
                    }}>
                        <tbody>
                            {searchFilteredData.length > 0 ? (
                                searchFilteredData.map((user, index) => (
                                    <tr
                                        key={user.userId || index}
                                        style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
                                    >
                                        <td style={{ ...tableCellStyle, width: '50px' }}>{index + 1}</td>

                                        {/* DATE */}
                                        <td style={{ ...tableCellStyle, width: '80px' }}>
                                            {formatDate(user.registeredTime)}
                                        </td>

                                        {/* TIME */}
                                        <td style={{ ...tableCellStyle, width: '80px' }}>
                                            {formatTime(user.registeredTime)}
                                        </td>

                                        <td style={{ ...tableCellStyle, width: '100px' }}>{user.userName}</td>
                                        <td style={{ ...tableCellStyle, width: '100px' }}>{user.userId}</td>
                                        <td style={{ ...tableCellStyle, width: '150px' }}>{user.emailId}</td>
                                        <td style={{ ...tableCellStyle, width: '100px' }}>{user.mobileNumber}</td>
                                        <td style={{ ...tableCellStyle, width: '90px' }}>{user.userType}</td>
                                        <td style={{ ...tableCellStyle, width: '70px' }}>
                                            {user.active ? "Active" : "Inactive"}
                                        </td>
                                        <td style={{ ...tableCellStyle, width: '70px' }}>
                                            <button style={viewBtn} onClick={() => fetchUserProfileById(user.userId)}>View</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" style={noDataStyle}>
                                        {data.length === 0
                                            ? "Loading data or no users found."
                                            : (searchQuery.trim() || selectedStatusFilter || selectedCategoryFilter)
                                                ? "No users found with the specified filters."
                                                : "No users match the current filters."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {selectedCustomer && (
                <div style={overlay}>
                    <div style={modal}>
                        <h4>User Details</h4>
                        <hr />

                        {loadingProfile ? (
                            <p>Loading user details...</p>
                        ) : (
                            <>
                                <p><b>Name:</b> {selectedCustomer.userName || "-"}</p>
                                <p><b>Email:</b> {selectedCustomer.emailId || "-"}</p>
                                <p><b>Mobile:</b> {selectedCustomer.mobileNumber || "-"}</p>

                                <p><b>Referral Code:</b> {selectedCustomer.referralCode || "-"}</p>
                                <p><b>Total Referrals:</b> {selectedCustomer.totalReferals ?? 0}</p>
                                <p><b>Total Cashback:</b> ₹{selectedCustomer.totalCashBack ?? 0}</p>

                                {/* Optional Image */}
                                {selectedCustomer.image && (
                                    <div style={{ marginTop: "10px" }}>
                                        <b>Profile Image:</b><br />
                                        <img
                                            src={selectedCustomer.image}
                                            alt="Profile"
                                            style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                        />
                                    </div>
                                )}
                            </>
                        )}

                        <div style={{ textAlign: "right", marginTop: "15px" }}>
                            <button
                                style={closeBtn}
                                onClick={() => setSelectedCustomer(null)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// Professional User Tab Component (Already imported)
// Post Paid Users Tab Component (Already imported)
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    padding: "6px",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const viewBtn = {
    background: "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    padding: "4px 12px",
    borderRadius: "6px",
    cursor: "pointer",
};

const closeBtn = {
    background: "#dc3545",
    color: "#fff",
    border: "none",
    padding: "6px 16px",
    borderRadius: "6px",
};

const overlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
};

const modal = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
};
const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

export default Userdetails;